/**
 * NOTE: 处理 webpack 代码切分的 path 路径，不清楚不要动。
 */
const REG_SRC = /^(https?:)?\/\/(.+)\/sc\/(.*)detail-fantasy\/([\d.]+)\//;

function getSrcMatch() {
  if (document.currentScript) {
    return document.currentScript.src.match(REG_SRC);
  } else {
    const elScripts = document.querySelectorAll('script[src]');
    // render脚本一般在最后，这里从后往前找，以便提升查找效率
    for (let i = elScripts.length - 1; i >= 0; i--) {
      const matches = elScripts[i].src.match(REG_SRC);
      if (matches) {
        return matches;
      }
    }
  }
}

export function getPublicPath() {
  const matches = getSrcMatch();
  return `//${matches[2]}/sc/detail-fantasy/${matches[4]}/`;
}

try {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = getPublicPath();
} catch (err) {
  // log('/sc.icbuShop.pubpatherror', 'EXP', err.stack);
  // 同构端不输出日志
  !window.__getComponentInNode && console.error(err);
}
